import { render } from "./CalendarJournalTable.vue?vue&type=template&id=d52545b8&scoped=true"
import script from "./CalendarJournalTable.vue?vue&type=script&lang=js"
export * from "./CalendarJournalTable.vue?vue&type=script&lang=js"

import "./CalendarJournalTable.vue?vue&type=style&index=0&id=d52545b8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d52545b8"]])

export default __exports__